import { Component } from '@angular/core';


@Component({
  selector: 'app-quote-note-control',
  templateUrl: './quote-note-control.component.html',
  styleUrls: ['./quote-note-control.component.scss'],
})
export class QuoteNoteControlComponent {
  public message: string;

  clearMessage() {
    this.message = '';
  }
}
